import React from "react"
import { CenterSelector } from "../features"

function RadCenterIndex(){   
    return <React.Fragment>
            <CenterSelector/>
    </React.Fragment>
}

export {RadCenterIndex}